<app-table
  [lazy]="true"
  [cols]="columns"
  tableTitle="Pagamento Duplicado (Payment)"
  [addButton]="false"
  [exportPdf]="false"
  [exportExcel]="false"
  [refreshButton]="false"
  [service]="itOpsService"
  pageFunctionName="getPaymentSameMonthTable"
  emptyMessage="Sem mais pagamentos duplicados (payment) no momento."
  selectionActionLabel="Corrigir"
  selectionActionTooltip="Marcar como resolvido"
  selectionActionIcon="pi pi-check"
  (emitSelection)="markAsResolved($event)"
  modelName="Registros"
  [defaultRows]="15"
></app-table>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
